export const gridTable = {
  toolbarConfig: {
    zoom: true,
    custom: true,
    slots: {
      buttons: "AI_toolbar_buttons",
    },
  },
  keepSource: true,
  resizable: true,
  border: true,
  stripe: true,
  highlightHoverRow: true,
  highlightCurrentRow: true,
  showHeaderOverflow: true,
  showOverflow: true,
  rowId: "id",
  height: "300",
  size: "small",
  columns: [],
  data: [],

  editConfig: {
    trigger: "dblclick",
    mode: "row",
    showIcon: false,
    // activeMethod: this.activeRowMethod,
    showStatus: true,
  },
  sortConfig: {
    trigger: "cell",
  },
};

// export const formatUpdateRows = ({ xGrid_, updateRecords }){

//   if (updateRecords.length !== 0) {
//     //判断行内那些值有改动
//     for (let i = 0; i < updateRecords.length; i++) {
//       var num = xGrid_.getRowIndex(updateRecords[i]);
//       var cols_length = this.cols;
//       for (let j = 0; j < cols_length.length; j++) {
//         var updateNewData = xGrid_.isUpdateByRow(updateRecords[i], "" + j);
//         if (updateNewData) {
//           for (let k = 0; k < this.gridOption2.columns.length; k++) {
//             var obj = {};
//             obj.redlineType = updateRecords[i].redlineType;
//             if (cols_length[j] == this.gridOption2.columns[k].attid) {
//               var quantity = cols_length[j];
//               obj.id = updateRecords[i].rowId;
//               console.log(this.gridOption2.columns[k]);
//               if (this.gridOption2.columns[k].editRender.props) {
//                 //处理多选和单选
//                 if (this.gridOption2.columns[k].editRender.props.multiple) {
//                   obj[quantity] = updateRecords[i][j].join(";");
//                 } else if (
//                   this.gridOption2.columns[k].editRender.props.type ==
//                   "datetime"
//                 ) {
//                   // obj[quantity] = updateRecords[i][j].format("yyyy-MM-ddThh:mm:ss");
//                   obj[quantity] = this.format(
//                     updateRecords[i][j],
//                     "yyyy-MM-ddThh:mm:ss"
//                   );
//                   console.log(obj[quantity]);
//                 } else {
//                   obj[quantity] = updateRecords[i][j] ?? "";
//                 }
//               } else {
//                 obj[quantity] = updateRecords[i][j] ?? "";
//               }
//               updateBom.push(obj);
//             }
//           }
//         }
//       }
//     }
//     const objUpdateIdList =
//       this.objId.classId == 10410
//         ? { title: "technologyObjId", url: "/pmdm/technology/updateTable" }
//         : { title: "itemObjId", url: "/pmdm/items/updateTable" };
//     var updateBomData = {
//       tableId:
//         this.objId.classId == 10410
//           ? 81
//           : this.Global.redLineBomTableId,
//       changeObjId: { ...this.objId },
//       [objUpdateIdList.title]: {
//         id: this.redLineRow.itemId,
//         classId: this.redLineRow.itemClassId,
//         subClassId: this.redLineRow.itemSubClassId,
//         version: this.version,
//       },
//       updateBom: this.arrGroup(updateBom),
//     };
//     return updateBomData;

//   }
// };


export const getRowCells = () => {

};

const LINK_LIST = [
  1003001, 1005001, 1006001, 1007007, 2000001, 1008001, 1009001, 1090001, 1096001, 1017001, 1013002, 1010002, 1015002, 1014002, 1095002, 1094002,
  1018001, 1093001, 1055001, 1054001, 4012001, 4011002,
  5013002, 5014001, 1025004, 5015001, 5011001, 5012007, 5021001, 5022001, 5016001, 5017001, 1024001,];
export const getNewTableTitleData = function (columnInfo, isCheckBox) {

  const data = [];
  if (isCheckBox !== "noCheckBox") {
    data.push({ type: "checkbox", width: 45, fixed: null, });
  }

  const { names, ids, attCtr, editable, uiTypes, listTypes, listIds, visible, listEntries } = columnInfo;

  const Arrowlist = [1003001, 5013002];
  for (let i = 0; i < attCtr; i++) {
    var obj = {
      minWidth: 120,
      title: names[i],
      field: i + "",
      attid: ids[i],
      sortable: true, //列表排序
      editable: editable[i] == 1,
      uiType: uiTypes[i],
      listType: listTypes[i] ?? 1,
      listId: listIds[i],
      treeNode: Arrowlist.includes(ids[i]), //是否有子菜单的箭头显示
      editRender: {
        enabled: editable[i] == 1,
      },
    };

    // if (i == 0) {
    // 	obj.treeNode = true; //是否有子菜单的箭头显示
    // };
    // const e = ids[i];
    // if (LINK_LIST.includes(e)) {
    //   obj.slots = {
    //     default: ({ row, column }, h) => {
    //       // 渲染链接
    //       return [
    //         <span
    //           class="link_"
    //           onClick={() => this.showDetailEvent(row, column)}
    //         >
    //           {" "}
    //           {row[column.property]}{" "}
    //         </span>,
    //       ];
    //     },
    //   };
    // }
    // if (e == 1016001 || e == 1016016) {
    //   obj.slots = {
    //     default: ({ row, column }, h) => {
    //       // 渲染链接
    //       return [
    //         <span class="link_" onClick={() => this.toLink(row, column)}>
    //           {" "}
    //           {row[column.property]}{" "}
    //         </span>,
    //       ];
    //     },
    //   };
    // }

    if (uiTypes[i] == 1) {
      obj.editRender = {
        name: "$input",
        // maxlength: '3'
        props: {
          maxlength: "240",
        },
      }; //不设置则不进入编辑模式
    } else if (uiTypes[i] == 2) {
      obj.width = 600
      obj.editRender = {
        name: "textarea",
        // maxlength: '3'
        props: {
          maxlength: "4000",
        },
      };
    } else if ([3, 4].includes(uiTypes[i])) {
      var select_id = listIds[i];
      //console.log(select_id);
      // var val =  listEntries[select_id] || {};
      var val =
        select_id === -1 ? {} : listEntries[select_id] || {};

      let editRender = {
        name: "$select",
        props: {
          clearable: true,
          multiple: uiTypes[i] === 4,
        },
        options: [],
      };
      if (select_id != -1) {
        for (const e in val) {
          editRender.options.push({ value: e, label: val[e] });
        }
      }
      obj.editRender = editRender;
    } else if (uiTypes[i] == 6) {
      obj.editRender = {
        name: "$input",
        props: {
          type: "datetime",
          //labelFormat: 'yyyy-MM-dd HH:mm:ss'
          // labelFormat: 'yyyy-MM-ddThh:mm:ss',
          // valueFormat: 'yyyy-MM-ddThh:mm:ss',
          transfer: true,
        },
      };
      // console.log("!");
    } else if (uiTypes[i] == 7) {
      obj.editRender = {
        name: "$input",
        props: {
          type: "number",
          clearable: true,
        },
      };
    } else if (uiTypes[i] == 10) {
      obj.editRender = {
        name: "$input",
        props: {
          type: "number",
          clearable: true,
        },
      };
    }

    if (visible[i] !== 0) {
      data.push(obj);
    }

    obj.editRender.enabled = !!obj.editable;
  }
  //console.log(data);
  return data;
};

export const getNewTableContentData = function (rows, columnInfo, projectName) {
  //获取到table进行格式转换
  var data = [];
  // console.log(res);
  var rows_val = rows ?? [];
  const { uiTypes, editable, listEntries = {}, listIds } = columnInfo;
  var rows_type = columnInfo.uiTypes;
  var rows_editable = columnInfo.editable;

  // const listEntries = columnInfo.listEntries || [];
  const listEntriesKeys = Object.keys(listEntries);
  const caslistEntries = listEntriesKeys.filter(
    (i) => Object.keys(listEntries[i]) == -1
  );
  const relTypeList = [{ id: 4, icon: "el-icon-connection" }];

  let casList = [];
  let ids = columnInfo.listIds;
  caslistEntries.map((i) => {
    listIds.map((j, e) => j == i && casList.push(e));
  });

  const enabled_ids = [1090002, 1092004];
  const enabled_indexs = columnInfo.ids.findIndex((i) =>
    enabled_ids.includes(i)
  );

  // rows.map((item, index) => {
  //   const cell = item.cells;
  // })

  for (var i = 0; i < rows_val.length; i++) {
    var rols_ = {};
    // console.log(rows_val[i]);
    let cellDisable = [];
    let changeIdIndex = 0; //获取表格变更列的版本id


    const item = rows_val[i];
    const { rowId, fileId, authTag, filePath, hasRev, isBOM, isFile, revNumberList, } = item

    for (var j = 0; j < rows_val[0].cells.length; j++) {
      if (columnInfo.ids[j] == 1003116) {
        //获取表格变更列的版本id
        changeIdIndex = j;
      }



      if (item.cells[j] == null) {
        (rols_[j] = ""), cellDisable.push("null");
      } else {
        // console.log(item.cells[j]);
        cellDisable.push(item.cells[j].editable);

        // if (listTypes[e] === 3) {
        //   if (uiTypes[e] == 3 && m.val) {
        //     listEntries[listIds[e]] = {
        //       ...listEntries[listIds[e]],
        //       [m.id]: m.val,
        //     };
        //   }
        //   if (uiTypes[e] == 4 && m.ids) {
        //     // listEntries[listIds[e]] = {[i.id]:i.val};
        //     const ids = m.ids.split(";");
        //     const vals = m.val.split(";");
        //     const obj = {};
        //     ids.map((j, x) => {
        //       obj[j] = vals[x];
        //     });
        //     listEntries[listIds[e]] = { ...listEntries[listIds[e]], ...obj };
        //   }
        // }

        if (rows_type[j] == 4) {
          rols_[j] = item.cells[j]?.ids || "";
          // rols_[j] = item.cells[j].ids;
          if (rols_[j] !== "") {
            rols_[j] = rols_[j].split(";");
          }
        } else if (rows_type[j] == 3) {
          if (casList.includes(j)) {
            rols_[j] =
              item.cells[j].id == -1 ? "" : item.cells[j].id;
          } else {
            const val = item.cells[j];
            rols_[j] =
              !rows_editable[j] || (val.val && ids[j] == -1)
                ? val.val
                : val.id;
          }

          //console.log(j);
          // console.log(item.cells[j]);
        } else if (rows_type[j] == 6) {
          if (item.cells[j].val == "") {
            rols_[j] = "";
          } else {
            const [a] = item.cells[j].val.split('T')
            rols_[j] = a
          }
          // console.log(rols_[j]);
        } else {
          rols_[j] = item.cells[j].val;
        }
      }
    }
    if (item.hasChildren == true) {
      rols_["hasChildren"] = item.hasChildren;
    }
    rols_["cellDisable"] = cellDisable;
    rols_["itemId"] = item.objId;
    rols_["itemClassId"] = item.objClass;
    rols_["itemSubClassId"] = item.objSubClass;
    rols_["relType"] =
      relTypeList.find((item) => item.id == (item?.relType || ""))
        ?.icon || "";

    rols_.objectId = {
      id: item.objId,
      classId: item.objClass,
      subClassId: item.objSubClass,
      name: "",
    };
    rols_ = { rowId, fileId, authTag, filePath, hasRev, isBOM, isFile, revNumberList, ...rols_ };

    if (enabled_indexs != -1) {
      rols_["status"] = item.cells[enabled_indexs].id == 1;
    }

    if (projectName == "performance") {
      rols_["changeId"] = "";
    } else {
      rols_["changeId"] = item.cells[changeIdIndex].id; //获取表格变更列的版本id
    }
    data.push(rols_);

  }
  //console.log(data);
  return data;
};

export const gridOptions = {
  toolbarConfig: {
    zoom: true,
    custom: true,
    print: true,
    slots: {
      buttons: "AI_toolbar_buttons",
    },
  },
  printConfig: {},
  keepSource: true,
  resizable: true,
  border: true,
  stripe: true,
  highlightHoverRow: true,
  highlightCurrentRow: true,
  // showHeaderOverflow: true,
  // showOverflow: true,
  rowId: "id",
  height: "600",
  size: "small",
  columns: [],
  data: [],
  treeConfig: {
    lazy: true,
    children: "children",
    hasChild: "hasChildren",
    // loadMethod: this.loadChildrenMethod,
  },
  editConfig: {
    trigger: "dblclick",
    mode: "row",
    showIcon: false,
    // activeMethod: this.activeRowMethod,
    showStatus: true,
  },
  sortConfig: {
    trigger: "cell",
  },
};

export function setListEntry({ listEntries, listTypes, uiTypes, listIds }, arr) {
  arr.map((i) => {
    const { cells } = i
    cells.map((m, e) => {
      if (listTypes[e] === 3) {
        if (uiTypes[e] == 3 && m.val) {
          listEntries[listIds[e]] = {
            ...listEntries[listIds[e]],
            [m.id]: m.val,
          };
        }
        if (uiTypes[e] == 4 && m.ids) {
          const ids = m.ids.split(";");
          const vals = m.val.split(";");
          const obj = {};
          ids.map((j, x) => {
            obj[j] = vals[x];
          });
          listEntries[listIds[e]] = { ...listEntries[listIds[e]], ...obj };
        }
      }
    });
  });
  return listEntries
};

export const getNewRedLineTableContentData = function (rows, columnInfo) {
  //获取到table进行格式转换
  //console.log(res);
  var data = [];
  //console.log(res.length);
  var rows_val = rows;
  var rows_type = columnInfo.uiTypes;
  var rows_editable = columnInfo.editable;
  for (var i = 0; i < rows_val.length; i++) {
    var rols_ = {};
    var rols_child = {};
    var redLine = [];
    //console.log(this.rols[i].cells);
    if (rows_val[i].redlineType == 1) {
      for (var j = 0; j < rows_val[0].cells.length; j++) {
        if (rows_val[i].cells[j] == null) {
          rols_[j] = "";
        } else {
          // rols_[j] = rows_val[i].cells[j].val;

          if (rows_type[j] == 4 && rows_editable[j] == 1) {
            rols_[j] = rows_val[i].cells[j]?.ids || "";
            if (rols_[j] !== "") {
              rols_[j] = rols_[j].split(";");
            }
          } else {
            rols_[j] = rows_val[i].cells[j].val;
          }

          redLine.push(j + 1);
        }
      }
      rols_["itemId"] = rows_val[i].objId;
      rols_["itemClassId"] = rows_val[i].objClass;
      rols_["itemSubClassId"] = rows_val[i].objSubClass;
      rols_.objectId = {
        id: rows_val[i].objId,
        classId: rows_val[i].Class,
        subClassId: rows_val[i].objSubClass,
        name: "",
      };
      rols_["rowId"] = rows_val[i].rowId;
      rols_["parentRowId"] = rows_val[i].parentRowId;
      rols_["redlineType"] = rows_val[i].redlineType;
      rols_["redText"] = redLine;
      data.push(rols_);
    } else if (rows_val[i].redlineType == 2) {
      for (var j = 0; j < rows_val[0].cells.length; j++) {
        if (rows_val[i].cells[j] == null || rows_val[i].cells[j].val == "") {
          rols_[j] = "";
        } else {
          // rols_[j] = rows_val[i].cells[j].val;

          if (rows_type[j] == 4 && rows_editable[j] == 1) {
            rols_[j] = rows_val[i].cells[j].ids;
            if (rols_[j] !== "") {
              rols_[j] = rols_[j].split(";");
            }
          } else {
            rols_[j] = rows_val[i].cells[j].val;
          }

          redLine.push(j + 1);
        }
      }
      rols_["itemId"] = rows_val[i].objId;
      rols_["itemClassId"] = rows_val[i].objClass;
      rols_["itemSubClassId"] = rows_val[i].objSubClass;
      rols_.objectId = {
        id: rows_val[i].objId,
        classId: rows_val[i].Class,
        subClassId: rows_val[i].objSubClass,
        name: "",
      };
      rols_["rowId"] = rows_val[i].rowId;
      rols_["parentRowId"] = rows_val[i].parentRowId;
      rols_["redlineType"] = rows_val[i].redlineType;
      rols_["disable"] = true;
      rols_["redLine"] = redLine;

      data.push(rols_);
    } else if (rows_val[i].redlineType == 3) {
      var showRedline = false;
      for (var j = 0; j < rows_val[0].cells.length; j++) {
        if (rows_val[i].cells[j] == null) {
          rols_[j] = "";
          rols_child[j] = "";
        } else if (rows_val[i].cells[j].val == rows_val[i].oldCells[j].val) {
          rols_child[j] = "";
          // rols_[j] = rows_val[i].cells[j].val;
          if (rows_type[j] == 4 && rows_editable[j] == 1) {
            rols_[j] = rows_val[i].cells[j].ids;
            if (rols_[j] !== "") {
              rols_[j] = rols_[j].split(";");
            }
          } else {
            rols_[j] = rows_val[i].cells[j].val;
          }
        } else {
          // rols_[j] = rows_val[i].cells[j].val;
          // rols_child[j] = rows_val[i].oldCells[j].val;

          if (rows_type[j] == 4 && rows_editable[j] == 1) {
            rols_[j] = rows_val[i].cells[j].ids;
            if (rols_[j] !== "") {
              rols_[j] = rols_[j].split(";");
            }
            rols_child[j] = rows_val[i].oldCells[j].ids;
            if (rols_child[j] !== "") {
              rols_child[j] = rols_child[j].split(";");
            }
          } else {
            rols_[j] = rows_val[i].cells[j].val;
            if (rows_val[i].oldCells[j].val == "") {
              rols_child[j] = "(  )";
            } else {
              rols_child[j] = rows_val[i].oldCells[j].val;
            }
          }

          redLine.push(j + 1);
          showRedline = true;
        }
      }
      rols_["itemId"] = rows_val[i].objId;
      rols_["itemClassId"] = rows_val[i].objClass;
      rols_["itemSubClassId"] = rows_val[i].objSubClass;
      rols_["rowId"] = rows_val[i].rowId;
      rols_["parentRowId"] = rows_val[i].parentRowId;
      rols_["redlineType"] = rows_val[i].redlineType;
      rols_["redText"] = redLine;

      const {
        rowId,
        parentRowId,
        redlineType,
        objId: id,
        objClass: classId,
        objSubClass: subClassId,
      } = rows_val[i];
      rols_.objectId = {
        rowId,
        parentRowId,
        redlineType,
        id,
        classId,
        subClassId,
      };
      data.push(rols_);

      rols_child["disable"] = true;
      rols_child["redLine"] = redLine;
      if (showRedline) {
        data.push(rols_child);
      }

      //console.log(data);
    } else if (rows_val[i].redlineType == 4) {
      for (var j = 0; j < rows_val[0].cells.length; j++) {
        if (rows_val[i].cells[j] == null) {
          rols_[j] = "";
        } else {
          // rols_[j] = rows_val[i].cells[j].val;

          if (rows_type[j] == 4 && rows_editable[j] == 1) {
            rols_[j] = rows_val[i].cells[j].ids;
            if (rols_[j] !== "") {
              rols_[j] = rols_[j].split(";");
            }
          } else {
            rols_[j] = rows_val[i].cells[j].val;
          }
        }
      }

      rols_["itemId"] = rows_val[i].objId;
      rols_["itemClassId"] = rows_val[i].objClass;
      rols_["itemSubClassId"] = rows_val[i].objSubClass;

      const {
        rowId,
        parentRowId,
        redlineType,
        objId: id,
        objClass: classId,
        objSubClass: subClassId,
      } = rows_val[i];
      rols_.objectId = {
        rowId,
        parentRowId,
        redlineType,
        id,
        classId,
        subClassId,
      };
      rols_.objectId = {
        id: rows_val[i].objId,
        classId: rows_val[i].Class,
        subClassId: rows_val[i].objSubClass,
        name: "",
      };
      rols_["rowId"] = rows_val[i].rowId;
      rols_["parentRowId"] = rows_val[i].parentRowId;
      rols_["redlineType"] = rows_val[i].redlineType;

      data.push(rols_);
    }
  }
  return data;
};

